
/**
 * A url modifier helper whch binds the paramters to ur lwritin in ract route
 *
 * @type       {Function}
 */
const UrlModifier = {

  _bind(target, item_key, value) {
    var replace = ":" + item_key;
    var re = new RegExp(replace,"g");
    return target.replace(re, value);
  },

  /**
   * Binds the paramters to URL
   *
   * @param      {string}  url     The url
   * @param      {Object}  params  The parameters
   * @return     {string}  { description_of_the_return_value }
   */
  bindToUrl(url, params) {
    const keys = Object.entries(params);
    for (const [name, key] of keys) {
      url = this._bind(url, name, key);
    }
    return url;
  },

  replaceAll(str, mapObj) {

    var newMapObj = {};
    const keys = Object.entries(mapObj);
    for (const [name, ] of keys) {
      newMapObj[ ":" + name ] = keys;
    }

    var re = new RegExp(Object.keys(newMapObj).join("|"),"gi");
    return str.replace(re, function(matched){
      return newMapObj[matched.toLowerCase()];
    });
  },

  paramsToObject(url) {
    let params = {};
    if (!url.includes("?")) {
      return params;
    }

    var search = url.split("?")[1];
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
      function(key, value) {
        return key===""?value:decodeURIComponent(value)
      }
    );
  }
};

export default UrlModifier;
